/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    '/public/blocks/new': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        post: operations['v1.public.blocks.create_new_block']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/public/occupation/types': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Used by the frontend to receive the *public* occupation status selection */
        get: operations['v1.public.occupation.get_occupation_types']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/public/salary/types': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Used by the frontend to receive the *public* salary status selection */
        get: operations['v1.public.salary.get_salary_types']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/public/user/contact-verification': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.public.contact-verification.status']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/public/user/contact-verification/request': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        post: operations['v1.public.contact-verification.request']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/public/user/contact-verification/verify': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        post: operations['v1.public.contact-verification.verify']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/public/user/info': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.public.user.get_user_info']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/public/user/occupation': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Used by the frontend to store the player's occupation */
        post: operations['v1.public.store_occupation']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/public/user/partner-data': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Get partner data for the authenticated user */
        get: operations['v1.public.user.get_partner_data']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/public/user/reality-check-setting': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.public.user.reality_check_setting.show']
        put?: never
        post: operations['v1.public.user.reality_check_setting.store']
        delete: operations['v1.public.user.reality_check_setting.destroy']
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/public/user/salary': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Used by the frontend to store the player's salary */
        post: operations['v1.public.store_salary']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/public/user/set-phone-number': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        /** Set phone number for user */
        put: operations['v1.public.user.set_phone_number']
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/public/user/set-phone-number-and-email': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        /** Set phone number and/or email for user */
        put: operations['v1.public.user.set_phone_number_and_email']
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/public/user/user-edit-data': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Gets data needed for the user edit page */
        get: operations['v1.public.user.get_user_edit_data']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/public/user/user-report': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** As user, request a user report1 */
        post: operations['v1.user.request_user_report_by_user']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/public/user/user-report/{playerReport}/download': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** /* Download a user report as a ZIP file by user */
        get: operations['v1.user.get_user_download_by_user']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/public/user/user-report/{playerReport}/status': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Get the download status of a user report */
        get: operations['v1.user.get_user_report_status']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/public/user/validate-signup': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        post: operations['v1.public.user.validate_signup']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/blocks/active/user/{user}': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.blocks.get_blocks_for_user']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/blocks/backoffice/block/remove/{blockId}': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        post: operations['v1.blocks.backoffice.remove_block']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/blocks/backoffice/cooldown/{player}/new': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Allow other services and backoffice users to create a cooldown for a player of any length */
        post: operations['v1.blocks.backoffice.create_new_cooldown']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/blocks/backoffice/player/{playerId}': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.blocks.backoffice.get_player_blocks']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/blocks/cooldown/{player}/new': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Allow other services and backoffice users to create a cooldown for a player of any length */
        post: operations['v1.blocks.cooldown.create_new_cooldown']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/blocks/cooldown/reconcile': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.blocks.cooldown.reconcile_cooldowns']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/blocks/player/{playerId}': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.blocks.get_all_blocks_for_player']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/data/{playerId}/audits': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.data.audits']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/data/{playerId}/blocks': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.data.blocks']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/data/{playerId}/closed-logs': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.data.closed_logs']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/data/{playerId}/cooldowns': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.data.cooldowns']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/data/{playerId}/deactivated-logs': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.data.deactivated_logs']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/data/{playerId}/event-logs': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.data.event_logs']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/data/{playerId}/flag-logs': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.data.flag_logs']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/data/{playerId}/suspension-logs': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.data.suspension_logs']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/flag': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Gets all flags from the player account database, with given fields and conditions */
        get: operations['v1.flag.index']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/partner-users': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.partner_users.index']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.player.index']
        put?: never
        /** Store a newly created player in storage */
        post: operations['v1.player.store']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player-event-log': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Store a newly created resource in storage */
        post: operations['v1.player_event_log.store']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player-flag': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Gets all playerflags with given fields and conditions */
        get: operations['v1.player_flag.index']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player-flag-log': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Gets playerflaglogs with given fields and conditions */
        get: operations['v1.player_flag_log.index']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player-flag/{playerFlag}': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        post?: never
        /** Endpoint to delete a playerFlag entry based on its id, and its corresponding PlayerFlagLog */
        delete: operations['v1.player_flag.destroy']
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player/{player}': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Display the specified resource for a single player */
        get: operations['v1.player.show']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player/{player}/exclusion': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.exclusion.get_status']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player/{player}/flag/add': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Endpoint to add a flag to a player */
        post: operations['v1.player.flag.add']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player/{player}/flag/remove': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Endpoint to remove a flag from a player */
        post: operations['v1.player.flag.remove']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player/{player}/flags': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Endpoint to get all flags for a player */
        get: operations['v1.player.flag.get_flags']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player/{player}/flags/{flagType}': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Endpoint to check if a player has a flag */
        get: operations['v1.player.flag.has_flag']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player/{player}/flags/{flagType}/has-had': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.player.flag.has_had']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player/{player}/get-all-users': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Endpoint to get all user from a player_id */
        get: operations['v1.player.get_all_users']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player/{player}/get-newest-user': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Endpoint to return the newest created user for a player. Can return closed users! */
        get: operations['v1.player.get_newest_user']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player/{player}/get-users-count': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Endpoint to get the count of users for a player */
        get: operations['v1.player.get_users_count']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player/{player}/getactiveuser': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Endpoint to return the latest active, non-closed user for a player */
        get: operations['v1.player.get_active_user']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player/{player}/player-event-logs': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Gets all player event logs for a player */
        get: operations['v1.player.get_all_player_event_logs_for_player']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player/flag/add': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        post: operations['v1.player.flag.batch_add']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player/flag/remove': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        post: operations['v1.player.flag.batch_remove']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player/get-newest-users': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /**
         * Batch getNewestUsers
         * @description Endpoint to return the newest created uses for a list of players. Can return closed users!
         */
        get: operations['v1.player.get_newest_users']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player/occupation': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Used by case-management, to save a players occupation from a case */
        post: operations['v1.player.store_occupation']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player/occupation/{player}': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Gets all occupations for a player */
        get: operations['v1.player.get_occupations']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player/occupation/types': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Used by case-management to receive all occupation status */
        get: operations['v1.player.occupation.get_occupation_types']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player/salary': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Used by case-management, to save a players salary from a case */
        post: operations['v1.player.store_salary']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player/salary/{player}': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Get the salary of a player */
        get: operations['v1.player.get_salary']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/player/salary/types': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Used by the frontend to receive the salary status selection */
        get: operations['v1.player.salary.get_salary_types']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/segment': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Gets all segments */
        get: operations['v1.segment.index']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/segment/{type}': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Gets a segment */
        get: operations['v1.segment.show']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/segment/{type}/player/{player}': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        post?: never
        /** Removes segment from player */
        delete: operations['v1.segment.player.remove_segment']
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/segment/{type}/players-count': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Gets all players in a segment */
        get: operations['v1.segment.players_count']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/segment/{type}/user/{user}': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        post?: never
        /** removes segment from user */
        delete: operations['v1.segment.user.remove_segment']
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/segment/player': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        /** Batch Adds segment to players */
        put: operations['v1.segment.player.batch_add_segment']
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/segment/player/{player}': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Gets segments for player */
        get: operations['v1.segment.player.get_segments']
        /** Adds segment to player */
        put: operations['v1.segment.player.add_segment']
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/segment/user': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        /** Batch Adds segment to users */
        put: operations['v1.segment.user.batch_add_segment']
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/segment/user/{user}': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Gets segments for user */
        get: operations['v1.segment.user.get_segments']
        /** Adds segment to user */
        put: operations['v1.segment.user.add_segment']
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Shows a paginated resource of all users */
        get: operations['v1.user.index']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user-brand': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.user_brand.get']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user-brand/newest-users': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.user_brand.newest_users']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/{user}': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Returns a single user */
        get: operations['v1.user.show']
        /** Update the specified resource in storage */
        put: operations['v1.user.update']
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/{user}/event-logs': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Get all event_logs for a user */
        get: operations['v1.user.flag.get_event_logs']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/{user}/flag-data': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Endpoint to get all flag resources for the user */
        get: operations['v1.user.flag.get_user_flag_data']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/{user}/flag-logs-data': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Gets all flaglogs for a user */
        get: operations['v1.user.flag_logs_data']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/{user}/flag/add': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Endpoint to add a flag to a user */
        post: operations['v1.user.flag.add']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/{user}/flag/batch-add': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Batch endpoint for adding multiple flags to the same user */
        post: operations['v1.user.flag.batch_add_to_user']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/{user}/flag/batch-remove': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Batch endpoint for removing multiple flags from the same user */
        post: operations['v1.user.flag.batch_remove_from_user']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/{user}/flag/remove': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Endpoint to remove a flag from a user */
        post: operations['v1.user.flag.remove']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/{user}/flags': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Endpoint to get all flags for the user */
        get: operations['v1.user.flag.get_flags']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/{user}/flags/{flagType}/has-had': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.user.flag.has_had']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/{user}/getallusersfromplayer': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.user.get_all_users_from_player']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/{user}/incident': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Triggers an incident on a user */
        post: operations['v1.user.incident.store']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/{user}/partner-data': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.user.get_partner_data']
        put?: never
        post: operations['v1.user.update_partner_data']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/{user}/payout-block': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Returns the payout block status of the user */
        get: operations['v1.user.payout_block']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/{user}/reports': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Get all user reports for a user */
        get: operations['v1.user.get_all_user_reports_for_user']
        put?: never
        /** As admin, request a user report */
        post: operations['v1.user.admin.request_user_report']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/{user}/reports/{playerReport}/download': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** As admin download a user report */
        get: operations['v1.user.get_user_report']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/{user}/signedup': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Signup flow player account */
        post: operations['v1.user.signed_up']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/{user}/similarity-check': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Returns array of users and similarity score above threshold */
        get: operations['v1.user.get_similar_users']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/{user}/update-validation-status': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        post: operations['v1.user.updateUserValidationStatus']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/{userId}/acl_attributes': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get: operations['v1.user.acl_attributes']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/flag/add': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Batch endpoint for adding a flag to multiple users */
        post: operations['v1.user.flag.batch_add']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/flag/remove': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Batch endpoint for removing a flag from multiple users */
        post: operations['v1.user.flag.batch_remove']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/incident': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Triggers an incident on multiple users */
        post: operations['v1.user.incident.batch_store']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/index-with-flags': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** Returns a paginated resource of all users, with all info on all the users flags */
        get: operations['v1.user.indexWithFlags']
        put?: never
        post?: never
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/update': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /** Update the specified resource in storage */
        post: operations['v1.user.batch_update']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
    '/v1/user/validate-signup': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        get?: never
        put?: never
        /**
         * Endpoint that runs a selected subset of validation rules for users trying to sign up
         * @description The validation result is used in monolith.
         *
         *     This means this endpoint facilitates moving parts of the validation logic out of the monolith.
         *
         *     The return value must be considered public, as it will be shown to the clients.
         *
         *     Once signup is moved out of monolith, this endpoint can be deleted.
         *
         *     The validation rules are defined on the UserSignupValidationRequest DTO, thus the controller is strictly empty.
         */
        post: operations['v1.user.validate_signup']
        delete?: never
        options?: never
        head?: never
        patch?: never
        trace?: never
    }
}
export type webhooks = Record<string, never>
export interface components {
    schemas: {
        /** BatchFlagsRequest */
        BatchFlagsRequest: {
            admin_user_id?: string
            /** Format: date-time */
            expires_at?: string | null
            reason?: string | null
            /** Format: date-time */
            sent_at?: string | null
            type?: string | null
            types: [
                string,
                ...string[]
            ]
        }
        /** BatchPlayerFlagRequest */
        BatchPlayerFlagRequest: {
            /**
             * @description The admin user id that triggered the request
             * @default 0
             */
            admin_user_id: number | null
            /**
             * Format: date-time
             * @description Time when the flag expires
             */
            expires_at?: string | null
            /** @description The players ids to add flag to */
            player_ids: Record<string, never>[]
            /** @description The reason for the flag */
            reason?: string | null
            /**
             * Format: date-time
             * @description When the flag was sent
             */
            sent_at?: string | null
            /** @description The IP used when signing up */
            type: string
        }
        /**
         * BatchPlayerSegmentRequest
         * @description Class SegmentRequest
         */
        BatchPlayerSegmentRequest: {
            player_ids: [
                string,
                ...string[]
            ]
            type: string
        }
        /** BatchUpdateUserRequest */
        BatchUpdateUserRequest: {
            address?: string | null
            /** @description This parameter is used in the Audit Log (Audit::execute()) */
            admin_user_id?: string
            /** Format: date */
            birthdate?: string
            birthyear?: number
            city?: string | null
            disable_updating_of_consent?: boolean
            /** @description In special cases, we might want to disable updating of Marketing Automation */
            disable_updating_of_marketing_automation?: boolean
            /**
             * Format: email
             * @description We support these attributes on the User model
             */
            email?: string
            first_name?: string
            last_name?: string
            name?: string
            phone?: string
            user_ids: [
                number,
                ...number[]
            ]
            zipcode?: string
        }
        /** BatchUserFlagRequest */
        BatchUserFlagRequest: {
            admin_user_id?: string
            /** Format: date-time */
            expires_at?: string | null
            reason?: string | null
            /** Format: date-time */
            sent_at?: string | null
            type: string
            user_ids: [
                number,
                ...number[]
            ]
        }
        /**
         * BatchUserIncidentRequest
         * @description Class BatchUserIncidentRequest
         */
        BatchUserIncidentRequest: {
            admin_user_id?: string
            payload?: string[] | null
            reason?: string | null
            sent_at?: string | null
            type: string
            user_ids: [
                number,
                ...number[]
            ]
        }
        /**
         * BatchUserSegmentRequest
         * @description Class SegmentRequest
         */
        BatchUserSegmentRequest: {
            type: string
            user_ids: [
                number,
                ...number[]
            ]
        }
        /**
         * BlockCategory
         * @description Categories of reasons for blocking a player.
         * @enum {string}
         */
        BlockCategory: BlockCategory
        /**
         * BlockDuration
         * @enum {string}
         */
        BlockDuration: BlockDuration
        /** BlockRepresentation */
        BlockRepresentation: {
            brand: components['schemas']['Brand']
            /** Format: date-time */
            canBeRemovedAt: string
            /** Format: date-time */
            createdAt: string
            deleted: boolean
            /** Format: date-time */
            deletedAt: string | null
            /** Format: date-time */
            endtime: string | null
            id: number
            indefinite: boolean
            /** Format: date-time */
            updatedAt: string
            userId: number
        }
        /**
         * BlockType
         * @enum {string}
         */
        BlockType: BlockType
        /**
         * Brand
         * @enum {string}
         */
        Brand: Brand
        /**
         * ContactType
         * @enum {string}
         */
        ContactType: ContactType
        /** ContactVerificationResponse */
        ContactVerificationResponse: {
            code: components['schemas']['PublicErrorCodes'] | null
            /** @description A message describing the status, should not be shown to the user, can be used for debug. Is not a secret */
            message: string | null
            /** @description The status of the contact verification request */
            status: string
        }
        /** ContactVerificationStatusResponse */
        ContactVerificationStatusResponse: {
            contact_value: string | null
            is_verified: boolean
            type: components['schemas']['ContactType']
            /** Format: date-time */
            verified_at: string | null
        }
        /** CooldownRepresentation */
        CooldownRepresentation: {
            brand: components['schemas']['Brand']
            /** Format: date-time */
            createdAt: string
            createdBy: string | null
            /** Format: date-time */
            endtime: string
            id: number
            processed: boolean
            reason: string
            /** Format: date-time */
            updatedAt: string
            userId: number
        }
        /** CountResponse */
        CountResponse: {
            count: number
        }
        /** DateIntervalRequest */
        DateIntervalRequest: {
            /** Format: date-time */
            from: string
            /** Format: date-time */
            to: string
        }
        /** ExclusionStatusResponse */
        ExclusionStatusResponse: {
            block: string | null
            cooldown: string | null
        }
        /** FieldsRequest */
        FieldsRequest: {
            /** @default [] */
            fields: string[]
        }
        /** Flag */
        Flag: {
            add_condition: string
            /** Format: date-time */
            created_at: string | null
            description: string
            effect: string
            icon: string
            icon_full_path: string
            id: number
            name: string
            owner: string
            require_reason: number
            slug: string
            type: string
            /** Format: date-time */
            updated_at: string | null
        }
        /** FlagRepresentation */
        FlagRepresentation: {
            addCondition: string
            description: string
            effect: string
            id: number
            name: string
            owner: string
            type: string
        }
        /** GetBlocksResponse */
        GetBlocksResponse: {
            blocks: components['schemas']['PresentedBlock'][]
            cooldowns: components['schemas']['PresentedCooldown'][]
            deactivations: components['schemas']['PresentedDeactivation'][]
            suspensions: components['schemas']['PresentedSuspension'][]
        }
        /** GetSalaryOptionsResponse */
        GetSalaryOptionsResponse: {
            from: number
            id: number
            label: string | null
            to: number | null
        }
        /** GetSalaryResponse */
        GetSalaryResponse: {
            player_id: string
            salaries: components['schemas']['SalaryRepresentation'][]
        }
        /** HasHadFlagResponse */
        HasHadFlagResponse: {
            /**
             * Format: date-time
             * @description When the user first had the flag
             */
            firstAdded: string | null
            /** @description If the user has had the flag at any point in time */
            hasHadFlag: boolean
        }
        /** LegacyUser */
        LegacyUser: {
            address: string | null
            anonymized: boolean | null
            birthdate: string | null
            city: string | null
            closed: boolean
            created: string
            customer_number: string
            email: string
            first_name: string | null
            id: number
            is_staff: number | null
            last_login: string
            last_name: string | null
            modified: string
            name: string
            phone: string | null
            phone_prefix: string
            player_id: string | null
            sex: string | null
            ssn: string | null
            suspended: number
            user_validation_status_id: number
            username: string
            zipcode: string | null
        }
        /** NewCooldownRequest */
        NewCooldownRequest: {
            brand?: components['schemas']['Brand'] | null
            category: components['schemas']['BlockCategory']
            /** Format: date-time */
            expiresAt: string
            onBehalfOfAdminUser?: string | null
            reason: string
        }
        /** OccupationRequest */
        OccupationRequest: {
            company_name?: string | null
            created_by?: string | null
            findings?: string | null
            /** @default false */
            high_risk_occupation: boolean
            job_title?: string | null
            occupation_status?: string | null
            player_id: string
        }
        /** PartnerUserRepresentation */
        PartnerUserRepresentation: {
            /** Format: date-time */
            created_at: string
            partner_user_id: string | null
            user_id: number
        }
        /** PartnerUsersRequest */
        PartnerUsersRequest: {
            afterId?: number | null
            /** Format: date-time */
            createdAfter?: string | null
            /** Format: date-time */
            createdBefore?: string | null
            partnerName: string
            perPage?: number | null
        }
        /** PartnerUsersResponse */
        PartnerUsersResponse: {
            data: components['schemas']['PartnerUserRepresentation'][]
            has_more_pages: boolean
        }
        /** Player */
        Player: {
            /** Format: date-time */
            created_at: string | null
            id: string
            /** Format: date-time */
            updated_at: string | null
        }
        /** PlayerBlock */
        PlayerBlock: {
            brand: components['schemas']['Brand'] | null
            category: components['schemas']['BlockCategory']
            /** Format: date-time */
            created_at: string
            created_by_admin: string | null
            created_by_authed_admin: string | null
            created_by_user_id: number | null
            /** Format: date-time */
            ended_at: string | null
            ended_by_admin: string | null
            ended_reason: string | null
            /** Format: date-time */
            expires_at: string | null
            id: number
            imported_id: number | null
            player_id: string
            reason: string
            type: components['schemas']['BlockType']
            /** Format: date-time */
            updated_at: string
        }
        /** PlayerEventLog */
        PlayerEventLog: {
            /** Format: date-time */
            created_at: string
            created_by: number
            id: number
            player_id: string
            reason: string | null
            type: components['schemas']['PlayerEventLogType']
            user_id: number
        }
        /** PlayerEventLogsRepresentation */
        PlayerEventLogsRepresentation: {
            /** Format: date-time */
            createdAt: string
            createdBy: string | null
            id: number
            playerId: string
            reason: string | null
            type: number
            userId: number
        }
        /**
         * PlayerEventLogType
         * @enum {integer}
         */
        PlayerEventLogType: PlayerEventLogType
        /** PlayerFlagLog */
        PlayerFlagLog: {
            /** Format: date-time */
            created_at: string | null
            created_by: string
            flag_id: number
            id: number
            player_id: string
            reason: string | null
            type: components['schemas']['PlayerFlagLogType']
            /** Format: date-time */
            updated_at: string | null
        }
        /** PlayerFlagLogsRepresentation */
        PlayerFlagLogsRepresentation: {
            added: boolean
            /** Format: date-time */
            createdAt: string | null
            createdBy: string | null
            flag: components['schemas']['FlagRepresentation']
            id: number
            playerId: string
            reason: string | null
            /** Format: date-time */
            updatedAt: string | null
            userId: number
        }
        /**
         * PlayerFlagLogType
         * @enum {integer}
         */
        PlayerFlagLogType: PlayerFlagLogType
        /** PlayerIndexRequest */
        PlayerIndexRequest: {
            /**
             * @default [
             *       "*"
             *     ]
             */
            fields: string[]
            /** @default 1 */
            page: number
            /** @default 1000 */
            perPage: number
            /** @default true */
            withNewestUser: boolean
        }
        /** PlayerReport */
        PlayerReport: {
            admin_id: number | null
            brand: components['schemas']['Brand']
            /** Format: date-time */
            created_at: string | null
            downloaded: boolean
            file: string | null
            id: number
            requested_by_admin: boolean
            state: components['schemas']['PlayerReportStateTypes']
            token: string | null
            /** Format: date-time */
            token_expires_at: string | null
            /** Format: date-time */
            updated_at: string | null
            user_id: number
        }
        /** PlayerReportByAdminRequest */
        PlayerReportByAdminRequest: {
            admin_id: number
            /** @default false */
            send_email: boolean
        }
        /**
         * PlayerReportStateTypes
         * @enum {string}
         */
        PlayerReportStateTypes: PlayerReportStateTypes
        /** PresentedBlock */
        PresentedBlock: {
            appliedByAdmin: string | null
            appliedByUserId: number | null
            canBeRemoved: boolean
            /** Format: date-time */
            canBeRemovedAt: string
            /** Format: date-time */
            createdAt: string
            durationSeconds: number | null
            /** Format: date-time */
            endedAt: string | null
            /** Format: date-time */
            expiresAt: string | null
            id: number
            isActive: boolean
            reason: string
            /** @default block */
            type: components['schemas']['BlockType']
            /** Format: date-time */
            updatedAt: string
        }
        /** PresentedCooldown */
        PresentedCooldown: {
            appliedByAdmin: string | null
            appliedByUserId: number | null
            /** Format: date-time */
            createdAt: string
            durationSeconds: number | null
            /** Format: date-time */
            endedAt: string | null
            /** Format: date-time */
            expiresAt: string | null
            id: number
            isActive: boolean
            reason: string
            /** @default cooldown */
            type: components['schemas']['BlockType']
            /** Format: date-time */
            updatedAt: string
        }
        /** PresentedDeactivation */
        PresentedDeactivation: {
            appliedByAdmin: string | null
            appliedByUserId: number | null
            /** Format: date-time */
            createdAt: string
            durationSeconds: number | null
            /** Format: date-time */
            endedAt: string | null
            /** Format: date-time */
            expiresAt: string | null
            id: number
            isActive: boolean
            reason: string
            /** @default deactivation */
            type: components['schemas']['BlockType']
            /** Format: date-time */
            updatedAt: string
        }
        /** PresentedSuspension */
        PresentedSuspension: {
            appliedByAdmin: string | null
            appliedByUserId: number | null
            /** Format: date-time */
            createdAt: string
            durationSeconds: number | null
            /** Format: date-time */
            endedAt: string | null
            /** Format: date-time */
            expiresAt: string | null
            id: number
            isActive: boolean
            reason: string
            /** @default suspension */
            type: components['schemas']['BlockType']
            /** Format: date-time */
            updatedAt: string
        }
        /**
         * PublicErrorCodes
         * @enum {string}
         */
        PublicErrorCodes: PublicErrorCodes
        /** PublicNewBlockRequest */
        PublicNewBlockRequest: {
            blockDuration: components['schemas']['BlockDuration']
            brand: components['schemas']['Brand']
            type: components['schemas']['BlockType']
        }
        /** PublicOccupationRequest */
        PublicOccupationRequest: {
            occupation_status?: string | null
        }
        /** PublicSalaryRequest */
        PublicSalaryRequest: {
            salary_id: number
        }
        /** RealityCheckSettingData */
        RealityCheckSettingData: {
            /** @description The amount of minutes between each reality check */
            intervalMinutes: number
        }
        /** RequestContactVerificationRequest */
        RequestContactVerificationRequest: {
            brand: components['schemas']['Brand']
            type: components['schemas']['ContactType']
        }
        /** SalaryRepresentation */
        SalaryRepresentation: {
            /** Format: date-time */
            created_at: string
            from: number
            salary_id: number
            to: number | null
        }
        /** SalaryRequest */
        SalaryRequest: {
            created_by?: string | null
            player_id: string
            salary_id: number
        }
        /** Segment */
        Segment: {
            /** Format: date-time */
            created_at: string | null
            description: string
            hex_color: string
            id: number
            type: string
            /** Format: date-time */
            updated_at: string | null
        }
        /**
         * SegmentRequest
         * @description Class SegmentRequest
         */
        SegmentRequest: {
            type: string
        }
        /** SetPhoneNumberAndEmailRequest */
        SetPhoneNumberAndEmailRequest: {
            email?: string | null
            phone?: string | null
        }
        /** SetPhoneNumberAndEmailResponse */
        SetPhoneNumberAndEmailResponse: {
            code: components['schemas']['PublicErrorCodes'] | null
            /** @description A message describing the status of the edit request, should not be shown to the user, can be used for debug. Is not a secret */
            message: string | null
            /** @description The status of the edit request */
            status: string
        }
        /** SetPhoneNumberRequest */
        SetPhoneNumberRequest: {
            /** @description The phone number to set */
            phone: string
        }
        /** SetPhoneNumberResponse */
        SetPhoneNumberResponse: {
            code: components['schemas']['PublicErrorCodes'] | null
            /** @description A message describing the status of the edit request, should not be shown to the user, can be used for debug. Is not a secret */
            message: string | null
            /** @description The status of the edit request */
            status: string
        }
        /** SignupValidationMetaDto */
        SignupValidationMetaDto: {
            privacyPolicy?: boolean | null
            terms?: boolean | null
        }
        /** StorePlayerEventLogRequest */
        StorePlayerEventLogRequest: {
            reason?: string | null
            type: components['schemas']['PlayerEventLogType']
            user_id: number
        }
        /**
         * StorePlayerRequest
         * @description Class StorePlayerRequest
         */
        StorePlayerRequest: {
            id?: string
        }
        /** StoreSalaryResponse */
        StoreSalaryResponse: {
            player_id: string
            saved_salary: components['schemas']['SalaryRepresentation']
        }
        /** StoreUserReportRequest */
        StoreUserReportRequest: {
            brand: components['schemas']['Brand']
        }
        /** UpdateUserRequest */
        UpdateUserRequest: {
            address?: string | null
            /** @description This parameter is used in the Audit Log (Audit::execute()) */
            admin_user_id?: string
            /** Format: date */
            birthdate?: string
            birthyear?: number
            city?: string | null
            disable_updating_of_consent?: boolean
            /** @description In special cases, we might want to disable updating of Marketing Automation */
            disable_updating_of_marketing_automation?: boolean
            /**
             * Format: email
             * @description We support these attributes on the User model
             */
            email?: string
            first_name?: string
            last_name?: string
            name?: string
            phone?: string
            zipcode?: string
        }
        /** UpdateUserValidationStatusRequest */
        UpdateUserValidationStatusRequest: {
            validationStatus: components['schemas']['UserValidationStatus']
        }
        /** UserAclAttributes */
        UserAclAttributes: {
            /** Format: date-time */
            blockEndTime: string | null
            /** Format: date-time */
            cooldownEndTime: string | null
            isBlocked: boolean
            isCooldowned: boolean
            isDeactivated: boolean
            isStaff: boolean
            isSuspended: boolean
            /** Format: date-time */
            userCreatedAt: string
        }
        /** UserAuditsRepresentation */
        UserAuditsRepresentation: {
            /** Format: date-time */
            createdAt: string | null
            event: string
            id: string
            newValue: string | null
            oldValue: string | null
            propertyName: string | null
            userId: number
        }
        /** UserBrand */
        UserBrand: {
            brand: components['schemas']['Brand']
            /** Format: date-time */
            first_login: string
            id: number
            /** Format: date-time */
            latest_login: string
            user_id: number
        }
        /** UserBrandIndexRequest */
        UserBrandIndexRequest: {
            brand?: components['schemas']['Brand'] | null
            /** Format: date-time */
            from?: string | null
            /** @default 1 */
            page: number
            /** @default 1000 */
            perPage: number
            /** @default DESC */
            sortOrder: string
            /** Format: date-time */
            to?: string | null
        }
        /** UserBrandRequest */
        UserBrandRequest: {
            userIds: number[]
        }
        /** UserBrandResponse */
        UserBrandResponse: {
            brand: components['schemas']['Brand']
            /**
             * Format: date-time
             * @description The timestamp of the first login for the user on the given brand
             */
            firstLogin: string
            /**
             * Format: date-time
             * @description The timestamp of the last login for the user on the given brand
             */
            latestLogin: string
            userId: number
        }
        /** UserCheckResult */
        UserCheckResult: {
            /**
             * @description Additional context for the check result, such as block end time, suspended date, etc
             * @default []
             */
            context: {
                [key: string]: unknown
            }
            /** @description The type of user check result */
            type: components['schemas']['UserCheckResultType']
        }
        /**
         * UserCheckResultType
         * @enum {string}
         */
        UserCheckResultType: UserCheckResultType
        /** UserClosedLogsRepresentation */
        UserClosedLogsRepresentation: {
            /** Format: date-time */
            createdAt: string | null
            createdBy: string | null
            id: number
            reason: string | null
            /** Format: date-time */
            updatedAt: string | null
            userId: number
        }
        /** UserEditDataResponse */
        UserEditDataResponse: {
            /** @description The pending email address for the user */
            pendingEmail: string | null
            /** @description Whether the user has rejected advertisements through a gambling authority */
            rejectedAdvertisement: boolean
        }
        /**
         * UserFlagRequest
         * @description Class UserFlagRequest
         */
        UserFlagRequest: {
            admin_user_id?: string
            /** Format: date-time */
            expires_at?: string | null
            reason?: string | null
            /** Format: date-time */
            sent_at?: string | null
            type: string
        }
        /**
         * UserIncidentRequest
         * @description Class UserIncidentRequest
         */
        UserIncidentRequest: {
            admin_user_id?: string
            payload?: string[] | null
            reason?: string | null
            sent_at?: string | null
            type: string
        }
        /** UserInfoResponse */
        UserInfoResponse: {
            address: string | null
            /**
             * @description Birthdate of the user in ISO 8601 format
             * @example 1990-01-01
             */
            birthDate: string | null
            checkResult: components['schemas']['UserCheckResult'] | null
            city: string | null
            /** Format: date-time */
            createdAt: string
            customerNumber: string
            email: string
            firstName: string | null
            fullName: string
            id: number
            /** @description Is the user blocked from making payouts */
            isPayoutBlocked: boolean
            isStaff: boolean
            isValidated: boolean
            lastName: string | null
            nthLogin: number
            nthLoginForBrand: number
            phone: string | null
            playerId: string
            sessionId: number
            username: string | null
            /** @description True if the user's first brand (per UserBrand) is different from the brand the request was made for */
            wasSoftSignedUp: boolean
            zipcode: string | null
        }
        /** UserPartnerDataResponse */
        UserPartnerDataResponse: {
            campaign_id: number | null
            partner_id: number
            partner_name: string
            partner_user_id: string | null
        }
        /** UserPartnerRequest */
        UserPartnerRequest: {
            /** @enum {integer} */
            partner_id: UserPartnerRequestPartner_id
        }
        /** UserPeriodRequest */
        UserPeriodRequest: {
            /** Format: date-time */
            from?: string | null
            /** Format: date-time */
            to?: string | null
        }
        /** UserSignedUpRequest */
        UserSignedUpRequest: {
            /** @description The brand the user signed up with */
            brand: string
            /** @description The bundle id the user signed up with */
            bundle_id?: number | null
            /** @description The IP used when signing up */
            ip?: string | null
            /**
             * Format: uuid
             * @description A pre-generated player id to use instead of creating a new one
             */
            player_id?: string | null
        }
        /** UserSignupDto */
        UserSignupDto: {
            address?: string | null
            birthdate?: string | null
            city?: string | null
            email?: string | null
            firstName?: string | null
            lastName?: string | null
            meta?: components['schemas']['SignupValidationMetaDto'] | null
            password?: string | null
            phone?: string | null
            ssn?: string | null
            username?: string | null
            zipcode?: string | null
        }
        /**
         * UserSignupValidationRequest
         * @description This class contains the current subset of validation rules that are handled in PA instead of monolith, as part of the ongoing effort to migrate validation logic.
         */
        UserSignupValidationRequest: {
            ssn: string
        }
        /**
         * UserValidationStatus
         * @enum {integer}
         */
        UserValidationStatus: UserValidationStatus
        /** ValidateSignupResponse */
        ValidateSignupResponse: {
            failures: {
                address?: string[]
                birthdate?: string[]
                city?: string[]
                email?: string[]
                firstName?: string[]
                lastName?: string[]
                password?: string[]
                phone?: string[]
                privacyPolicy?: string[]
                ssn?: string[]
                terms?: string[]
                username?: string[]
                zipcode?: string[]
            }
            meta: {
                existingUser?: {
                    exists: boolean
                    onCurrentBrand: boolean
                }
                isEligibleForSignup?: boolean
            }
        }
        /** VerifyContactRequest */
        VerifyContactRequest: {
            /** Format: uuid */
            token: string
        }
    }
    responses: {
        /** @description Not found */
        ModelNotFoundException: {
            headers: {
                [name: string]: unknown
            }
            content: {
                'application/json': {
                    /** @description Error overview. */
                    message: string
                }
            }
        }
        /** @description Validation error */
        ValidationException: {
            headers: {
                [name: string]: unknown
            }
            content: {
                'application/json': {
                    /** @description A detailed description of each field that failed validation. */
                    errors: {
                        [key: string]: string[]
                    }
                    /** @description Errors overview. */
                    message: string
                }
            }
        }
    }
    parameters: never
    requestBodies: never
    headers: never
    pathItems: never
}
export type $defs = Record<string, never>
export interface operations {
    'v1.public.blocks.create_new_block': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** @description `PublicNewBlockRequest` */
        requestBody: {
            content: {
                'application/json': components['schemas']['PublicNewBlockRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.public.occupation.get_occupation_types': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        [key: string]: unknown
                    }
                }
            }
        }
    }
    'v1.public.salary.get_salary_types': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['GetSalaryOptionsResponse'][]
                }
            }
        }
    }
    'v1.public.contact-verification.status': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description `ContactVerificationStatusResponse` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['ContactVerificationStatusResponse']
                }
            }
        }
    }
    'v1.public.contact-verification.request': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** @description `RequestContactVerificationRequest` */
        requestBody: {
            content: {
                'application/json': components['schemas']['RequestContactVerificationRequest']
            }
        }
        responses: {
            /** @description `ContactVerificationResponse` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['ContactVerificationResponse']
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.public.contact-verification.verify': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** @description `VerifyContactRequest` */
        requestBody: {
            content: {
                'application/json': components['schemas']['VerifyContactRequest']
            }
        }
        responses: {
            /** @description `ContactVerificationResponse` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['ContactVerificationResponse']
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.public.user.get_user_info': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description `UserInfoResponse` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['UserInfoResponse']
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.public.store_occupation': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** @description `PublicOccupationRequest` */
        requestBody?: {
            content: {
                'application/json': components['schemas']['PublicOccupationRequest']
            }
        }
        responses: {
            201: {
                headers: {
                    [name: string]: unknown
                }
                content?: never
            }
            400: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        /** @constant */
                        message: 'Invalid occupation provided.'
                    }
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.public.user.get_partner_data': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description `UserPartnerDataResponse` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['UserPartnerDataResponse']
                }
            }
            /** @description No content */
            204: {
                headers: {
                    [name: string]: unknown
                }
                content?: never
            }
        }
    }
    'v1.public.user.reality_check_setting.show': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description `RealityCheckSettingData` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['RealityCheckSettingData'] | Record<string, never>
                }
            }
        }
    }
    'v1.public.user.reality_check_setting.store': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** @description `RealityCheckSettingData` */
        requestBody: {
            content: {
                'application/json': components['schemas']['RealityCheckSettingData']
            }
        }
        responses: {
            /** @description `RealityCheckSettingData` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['RealityCheckSettingData']
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.public.user.reality_check_setting.destroy': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
        }
    }
    'v1.public.store_salary': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** @description `PublicSalaryRequest` */
        requestBody: {
            content: {
                'application/json': components['schemas']['PublicSalaryRequest']
            }
        }
        responses: {
            /** @description `StoreSalaryResponse` */
            201: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['StoreSalaryResponse']
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.public.user.set_phone_number': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** @description `SetPhoneNumberRequest` */
        requestBody: {
            content: {
                'application/json': components['schemas']['SetPhoneNumberRequest']
            }
        }
        responses: {
            /** @description `SetPhoneNumberResponse` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['SetPhoneNumberResponse']
                }
            }
            /** @description `SetPhoneNumberResponse` */
            422: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['SetPhoneNumberResponse']
                }
            }
        }
    }
    'v1.public.user.set_phone_number_and_email': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** @description `SetPhoneNumberAndEmailRequest` */
        requestBody?: {
            content: {
                'application/json': components['schemas']['SetPhoneNumberAndEmailRequest']
            }
        }
        responses: {
            /** @description `SetPhoneNumberAndEmailResponse` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['SetPhoneNumberAndEmailResponse']
                }
            }
            /** @description `SetPhoneNumberAndEmailResponse` */
            422: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['SetPhoneNumberAndEmailResponse']
                }
            }
        }
    }
    'v1.public.user.get_user_edit_data': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description `UserEditDataResponse` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['UserEditDataResponse']
                }
            }
        }
    }
    'v1.user.request_user_report_by_user': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** @description `StoreUserReportRequest` */
        requestBody: {
            content: {
                'application/json': components['schemas']['StoreUserReportRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        message: null | unknown[] | string
                    }
                }
            }
            422: components['responses']['ValidationException']
            429: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        message: null | unknown[] | string
                    }
                }
            }
        }
    }
    'v1.user.get_user_download_by_user': {
        parameters: {
            query?: {
                token?: string
            }
            header?: never
            path: {
                /** @description The player report ID */
                playerReport: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.user.get_user_report_status': {
        parameters: {
            query?: {
                token?: string
            }
            header?: never
            path: {
                /** @description The player report ID */
                playerReport: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.public.user.validate_signup': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** @description `UserSignupDto` */
        requestBody?: {
            content: {
                'application/json': components['schemas']['UserSignupDto']
            }
        }
        responses: {
            /** @description `ValidateSignupResponse` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['ValidateSignupResponse']
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.blocks.get_blocks_for_user': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['PlayerBlock'][]
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.blocks.backoffice.remove_block': {
        parameters: {
            query?: never
            header?: never
            path: {
                blockId: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            /** @description Bad request */
            400: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        /** @description Error overview. */
                        message: string
                    }
                }
            }
        }
    }
    'v1.blocks.backoffice.create_new_cooldown': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The player ID */
                player: string
            }
            cookie?: never
        }
        /** @description `NewCooldownRequest` */
        requestBody: {
            content: {
                'application/json': components['schemas']['NewCooldownRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'v1.blocks.backoffice.get_player_blocks': {
        parameters: {
            query?: never
            header?: never
            path: {
                playerId: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description `GetBlocksResponse` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['GetBlocksResponse']
                }
            }
        }
    }
    'v1.blocks.cooldown.create_new_cooldown': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The player ID */
                player: string
            }
            cookie?: never
        }
        /** @description `NewCooldownRequest` */
        requestBody: {
            content: {
                'application/json': components['schemas']['NewCooldownRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'v1.blocks.cooldown.reconcile_cooldowns': {
        parameters: {
            query: {
                from: string
                to: string
            }
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description `CountResponse` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['CountResponse']
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.blocks.get_all_blocks_for_player': {
        parameters: {
            query?: never
            header?: never
            path: {
                playerId: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description `GetBlocksResponse` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['GetBlocksResponse']
                }
            }
        }
    }
    'v1.data.audits': {
        parameters: {
            query?: {
                from?: string | null
                to?: string | null
            }
            header?: never
            path: {
                playerId: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['UserAuditsRepresentation'][]
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.data.blocks': {
        parameters: {
            query?: {
                from?: string | null
                to?: string | null
            }
            header?: never
            path: {
                playerId: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['BlockRepresentation'][]
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.data.closed_logs': {
        parameters: {
            query?: {
                from?: string | null
                to?: string | null
            }
            header?: never
            path: {
                playerId: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['UserClosedLogsRepresentation'][]
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.data.cooldowns': {
        parameters: {
            query?: {
                from?: string | null
                to?: string | null
            }
            header?: never
            path: {
                playerId: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['CooldownRepresentation'][]
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.data.deactivated_logs': {
        parameters: {
            query?: {
                from?: string | null
                to?: string | null
            }
            header?: never
            path: {
                playerId: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': string[]
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.data.event_logs': {
        parameters: {
            query?: {
                from?: string | null
                to?: string | null
            }
            header?: never
            path: {
                playerId: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['PlayerEventLogsRepresentation'][]
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.data.flag_logs': {
        parameters: {
            query?: {
                from?: string | null
                to?: string | null
            }
            header?: never
            path: {
                playerId: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['PlayerFlagLogsRepresentation'][]
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.data.suspension_logs': {
        parameters: {
            query?: {
                from?: string | null
                to?: string | null
            }
            header?: never
            path: {
                playerId: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': string[]
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.flag.index': {
        parameters: {
            query?: {
                'conditions'?: {
                    field?: string
                    operator?: string
                    value?: string
                }[]
                'fields[]'?: string[]
                'orderBy'?: {
                    field?: string
                    /** @enum {string} */
                    type?: PathsV1FlagGetParametersQueryOrderByType
                }[]
                'simplePaginate'?: boolean
            }
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['Flag'][]
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.partner_users.index': {
        parameters: {
            query: {
                afterId?: number | null
                createdAfter?: string | null
                createdBefore?: string | null
                partnerName: string
                perPage?: number | null
            }
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description `PartnerUsersResponse` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['PartnerUsersResponse']
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.player.index': {
        parameters: {
            query?: {
                fields?: string[]
                page?: number
                perPage?: number
                withNewestUser?: boolean
            }
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.player.store': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: {
            content: {
                'application/json': components['schemas']['StorePlayerRequest']
            }
        }
        responses: {
            /** @description `Player` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never> | components['schemas']['Player']
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.player_event_log.store': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** @description `StorePlayerEventLogRequest` */
        requestBody: {
            content: {
                'application/json': components['schemas']['StorePlayerEventLogRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.player_flag.index': {
        parameters: {
            query?: {
                'conditions'?: {
                    field?: string
                    operator?: string
                    value?: string
                }[]
                'fields[]'?: string[]
                'orderBy'?: {
                    field?: string
                    /** @enum {string} */
                    type?: PathsV1PlayerFlagGetParametersQueryOrderByType
                }[]
                'page'?: number
                'perPage'?: number
                'simplePaginate'?: boolean
            }
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.player_flag_log.index': {
        parameters: {
            query?: {
                'conditions'?: {
                    field?: string
                    operator?: string
                    value?: string
                }[]
                'fields[]'?: string[]
                'orderBy'?: {
                    field?: string
                    /** @enum {string} */
                    type?: PathsV1PlayerFlagLogGetParametersQueryOrderByType
                }[]
                'page'?: number
                'perPage'?: number
                'simplePaginate'?: boolean
            }
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.player_flag.destroy': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The player flag ID */
                playerFlag: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.player.show': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The player ID */
                player: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description `Player` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['Player']
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.exclusion.get_status': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The player ID */
                player: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description `ExclusionStatusResponse` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['ExclusionStatusResponse']
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.player.flag.add': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The player ID */
                player: string
            }
            cookie?: never
        }
        requestBody: {
            content: {
                'application/json': components['schemas']['UserFlagRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'v1.player.flag.remove': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The player ID */
                player: string
            }
            cookie?: never
        }
        requestBody: {
            content: {
                'application/json': components['schemas']['UserFlagRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'v1.player.flag.get_flags': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The player ID */
                player: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': unknown
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.player.flag.has_flag': {
        parameters: {
            query?: never
            header?: never
            path: {
                flagType: string
                /** @description The player ID */
                player: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        [key: string]: boolean
                    }
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.player.flag.has_had': {
        parameters: {
            query?: never
            header?: never
            path: {
                flagType: string
                /** @description The player ID */
                player: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description `HasHadFlagResponse` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['HasHadFlagResponse']
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.player.get_all_users': {
        parameters: {
            query?: {
                'conditions'?: {
                    field?: string
                    operator?: string
                    value?: string
                }[]
                'fields[]'?: string[]
                'orderBy'?: {
                    field?: string
                    /** @enum {string} */
                    type?: PathsV1PlayerPlayerGetAllUsersGetParametersQueryOrderByType
                }[]
                'simplePaginate'?: boolean
            }
            header?: never
            path: {
                /** @description The player ID */
                player: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['LegacyUser'][]
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'v1.player.get_newest_user': {
        parameters: {
            query?: {
                fields?: string[]
            }
            header?: never
            path: {
                /** @description The player ID */
                player: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        [key: string]: unknown
                    }
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'v1.player.get_users_count': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The player ID */
                player: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        count: number
                    }
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.player.get_active_user': {
        parameters: {
            query?: {
                fields?: string[]
            }
            header?: never
            path: {
                /** @description The player ID */
                player: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        [key: string]: unknown
                    }
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'v1.player.get_all_player_event_logs_for_player': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The player ID */
                player: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['PlayerEventLog'][]
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.player.flag.batch_add': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** @description `BatchPlayerFlagRequest` */
        requestBody: {
            content: {
                'application/json': components['schemas']['BatchPlayerFlagRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.player.flag.batch_remove': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** @description `BatchPlayerFlagRequest` */
        requestBody: {
            content: {
                'application/json': components['schemas']['BatchPlayerFlagRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.player.get_newest_users': {
        parameters: {
            query: {
                'fields[]'?: string[]
                'player_ids[]': string[]
            }
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        [key: string]: unknown
                    }[]
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.player.store_occupation': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** @description `OccupationRequest` */
        requestBody: {
            content: {
                'application/json': components['schemas']['OccupationRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        saved_occupation: string
                    }
                }
            }
            400: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        /** @constant */
                        message: 'Invalid occupation provided.'
                    }
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.player.get_occupations': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The player ID */
                player: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        occupations: string
                        player_id: string
                    }
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.player.occupation.get_occupation_types': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        [key: string]: unknown
                    }
                }
            }
        }
    }
    'v1.player.store_salary': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** @description `SalaryRequest` */
        requestBody: {
            content: {
                'application/json': components['schemas']['SalaryRequest']
            }
        }
        responses: {
            /** @description `StoreSalaryResponse` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['StoreSalaryResponse']
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.player.get_salary': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The player ID */
                player: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description `GetSalaryResponse` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['GetSalaryResponse']
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.player.salary.get_salary_types': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['GetSalaryOptionsResponse'][]
                }
            }
        }
    }
    'v1.segment.index': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['Segment'][]
                }
            }
        }
    }
    'v1.segment.show': {
        parameters: {
            query?: never
            header?: never
            path: {
                type: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description `Segment` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['Segment']
                }
            }
        }
    }
    'v1.segment.player.remove_segment': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The player ID */
                player: string
                type: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.segment.players_count': {
        parameters: {
            query?: never
            header?: never
            path: {
                type: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        player_count: number
                    }
                }
            }
        }
    }
    'v1.segment.user.remove_segment': {
        parameters: {
            query?: never
            header?: never
            path: {
                type: string
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.segment.player.batch_add_segment': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        requestBody: {
            content: {
                'application/json': components['schemas']['BatchPlayerSegmentRequest']
            }
        }
        responses: {
            201: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        /** @constant */
                        message: 'Succesfully added segment to players'
                    }
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.segment.player.get_segments': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The player ID */
                player: string
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['Segment'][]
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.segment.player.add_segment': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The player ID */
                player: string
            }
            cookie?: never
        }
        requestBody: {
            content: {
                'application/json': components['schemas']['SegmentRequest']
            }
        }
        responses: {
            201: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        /** @constant */
                        message: 'Succesfully added segment to player'
                    }
                }
            }
            /** @description No content */
            204: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        /** @constant */
                        message: 'Player already had segment'
                    }
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'v1.segment.user.batch_add_segment': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        requestBody: {
            content: {
                'application/json': components['schemas']['BatchUserSegmentRequest']
            }
        }
        responses: {
            201: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        /** @constant */
                        message: 'Succesfully added segment to users'
                    }
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.segment.user.get_segments': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['Segment'][]
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.segment.user.add_segment': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody: {
            content: {
                'application/json': components['schemas']['SegmentRequest']
            }
        }
        responses: {
            201: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        /** @constant */
                        message: 'Succesfully added segment to user'
                    }
                }
            }
            /** @description No content */
            204: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        /** @constant */
                        message: 'User already had segment'
                    }
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'v1.user.index': {
        parameters: {
            query?: {
                'conditions'?: {
                    field?: string
                    operator?: string
                    value?: string
                }[]
                'fields[]'?: string[]
                'orderBy'?: {
                    field?: string
                    /** @enum {string} */
                    type?: PathsV1UserGetParametersQueryOrderByType
                }[]
                'page'?: number
                'perPage'?: number
                'simplePaginate'?: boolean
                'withClosedUsers'?: boolean
                'withFlags[]'?: string[]
            }
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.user_brand.get': {
        parameters: {
            query: {
                userIds: number[]
            }
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description The collection of `UserBrandResponse` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['UserBrandResponse'][]
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.user_brand.newest_users': {
        parameters: {
            query?: {
                brand?: components['schemas']['Brand'] | null
                from?: string | null
                page?: number
                perPage?: number
                sortOrder?: string
                to?: string | null
            }
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description Paginated set of `UserBrand` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        current_page: number
                        data: components['schemas']['UserBrand'][]
                        first_page_url: string | null
                        from: number | null
                        last_page: number
                        last_page_url: string | null
                        /** @description Generated paginator links. */
                        links: {
                            active: boolean
                            label: string
                            url: string | null
                        }[]
                        next_page_url: string | null
                        /** @description Base path for paginator generated URLs. */
                        path: string | null
                        /** @description Number of items shown per page. */
                        per_page: number
                        prev_page_url: string | null
                        /** @description Number of the last item in the slice. */
                        to: number | null
                        /** @description Total number of items being paginated. */
                        total: number
                    }
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.user.show': {
        parameters: {
            query?: {
                'fields[]'?: string[]
            }
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description `LegacyUser` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['LegacyUser']
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'v1.user.update': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody?: {
            content: {
                'application/json': components['schemas']['UpdateUserRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'v1.user.flag.get_event_logs': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['PlayerEventLog'][]
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.user.flag.get_user_flag_data': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>[]
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.user.flag_logs_data': {
        parameters: {
            query?: {
                'conditions'?: {
                    field?: string
                    operator?: string
                    value?: string
                }[]
                'fields[]'?: string[]
                'orderBy'?: {
                    field?: string
                    /** @enum {string} */
                    type?: PathsV1UserUserFlagLogsDataGetParametersQueryOrderByType
                }[]
            }
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['PlayerFlagLog'][]
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'v1.user.flag.add': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody: {
            content: {
                'application/json': components['schemas']['UserFlagRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'v1.user.flag.batch_add_to_user': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody: {
            content: {
                'application/json': components['schemas']['BatchFlagsRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'v1.user.flag.batch_remove_from_user': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody: {
            content: {
                'application/json': components['schemas']['BatchFlagsRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'v1.user.flag.remove': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody: {
            content: {
                'application/json': components['schemas']['UserFlagRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'v1.user.flag.get_flags': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.user.flag.has_had': {
        parameters: {
            query?: never
            header?: never
            path: {
                flagType: string
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description `HasHadFlagResponse` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['HasHadFlagResponse']
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.user.get_all_users_from_player': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['LegacyUser'][]
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.user.incident.store': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody: {
            content: {
                'application/json': components['schemas']['UserIncidentRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'v1.user.get_partner_data': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description `UserPartnerDataResponse` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['UserPartnerDataResponse']
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.user.update_partner_data': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody: {
            content: {
                'application/json': components['schemas']['UserPartnerRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        /** @constant */
                        message: 'Partner data updated successfully.'
                    }
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'v1.user.payout_block': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        is_blocked: string
                    }
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.user.get_all_user_reports_for_user': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        reports: components['schemas']['PlayerReport'][]
                    }
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.user.admin.request_user_report': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        /** @description `PlayerReportByAdminRequest` */
        requestBody: {
            content: {
                'application/json': components['schemas']['PlayerReportByAdminRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        message: null | unknown[] | string
                    }
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
            429: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        message: null | unknown[] | string
                    }
                }
            }
        }
    }
    'v1.user.get_user_report': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The player report ID */
                playerReport: number
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            403: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        message: null | unknown[] | string
                    }
                }
            }
            404: components['responses']['ModelNotFoundException']
        }
    }
    'v1.user.signed_up': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        /** @description `UserSignedUpRequest` */
        requestBody: {
            content: {
                'application/json': components['schemas']['UserSignedUpRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        player_id: Record<string, never>
                        success: boolean
                    }
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'v1.user.get_similar_users': {
        parameters: {
            query?: {
                comparingTopResults?: number
                dryRun?: boolean
                thresholdPercentage?: number
            }
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        /** @constant */
                        message: 'Similarity check has been queued, and will soon be executed in the background.'
                        success: boolean
                    }
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'v1.user.updateUserValidationStatus': {
        parameters: {
            query?: never
            header?: never
            path: {
                /** @description The user ID */
                user: number
            }
            cookie?: never
        }
        /** @description `UpdateUserValidationStatusRequest` */
        requestBody: {
            content: {
                'application/json': components['schemas']['UpdateUserValidationStatusRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            404: components['responses']['ModelNotFoundException']
            422: components['responses']['ValidationException']
        }
    }
    'v1.user.acl_attributes': {
        parameters: {
            query?: never
            header?: never
            path: {
                userId: number
            }
            cookie?: never
        }
        requestBody?: never
        responses: {
            /** @description `UserAclAttributes` */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': components['schemas']['UserAclAttributes']
                }
            }
        }
    }
    'v1.user.flag.batch_add': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        requestBody: {
            content: {
                'application/json': components['schemas']['BatchUserFlagRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.user.flag.batch_remove': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        requestBody: {
            content: {
                'application/json': components['schemas']['BatchUserFlagRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.user.incident.batch_store': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        requestBody: {
            content: {
                'application/json': components['schemas']['BatchUserIncidentRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.user.indexWithFlags': {
        parameters: {
            query?: {
                'conditions'?: {
                    field?: string
                    operator?: string
                    value?: string
                }[]
                'current_page'?: number
                'fields[]'?: string[]
                'orderBy'?: {
                    field?: string
                    /** @enum {string} */
                    type?: PathsV1UserIndexWithFlagsGetParametersQueryOrderByType
                }[]
                'page'?: number
                'perPage'?: number
                'simplePaginate'?: boolean
                'withClosedUsers'?: boolean
                'withFlags[]'?: string[]
            }
            header?: never
            path?: never
            cookie?: never
        }
        requestBody?: never
        responses: {
            /**
             * @description Paginated set of `LegacyUser`
             *
             *     Paginated set of `LegacyUser`
             */
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': {
                        current_page: number
                        data: components['schemas']['LegacyUser'][]
                        first_page_url: string | null
                        from: number | null
                        last_page: number
                        last_page_url: string | null
                        /** @description Generated paginator links. */
                        links: {
                            active: boolean
                            label: string
                            url: string | null
                        }[]
                        next_page_url: string | null
                        /** @description Base path for paginator generated URLs. */
                        path: string | null
                        /** @description Number of items shown per page. */
                        per_page: number
                        prev_page_url: string | null
                        /** @description Number of the last item in the slice. */
                        to: number | null
                        /** @description Total number of items being paginated. */
                        total: number
                    } | {
                        current_page: number
                        data: components['schemas']['LegacyUser'][]
                        first_page_url: string | null
                        from: number | null
                        next_page_url: string | null
                        /** @description Base path for paginator generated URLs. */
                        path: string | null
                        /** @description Number of items shown per page. */
                        per_page: number
                        prev_page_url: string | null
                        /** @description Number of the last item in the slice. */
                        to: number | null
                    }
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.user.batch_update': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        requestBody: {
            content: {
                'application/json': components['schemas']['BatchUpdateUserRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            422: components['responses']['ValidationException']
        }
    }
    'v1.user.validate_signup': {
        parameters: {
            query?: never
            header?: never
            path?: never
            cookie?: never
        }
        /** @description `UserSignupValidationRequest` */
        requestBody: {
            content: {
                'application/json': components['schemas']['UserSignupValidationRequest']
            }
        }
        responses: {
            200: {
                headers: {
                    [name: string]: unknown
                }
                content: {
                    'application/json': Record<string, never>
                }
            }
            422: components['responses']['ValidationException']
        }
    }
}
export enum PathsV1FlagGetParametersQueryOrderByType {
    asc = 'asc',
    desc = 'desc',
    ASC = 'ASC',
    DESC = 'DESC'
}
export enum PathsV1PlayerFlagGetParametersQueryOrderByType {
    asc = 'asc',
    desc = 'desc',
    ASC = 'ASC',
    DESC = 'DESC'
}
export enum PathsV1PlayerFlagLogGetParametersQueryOrderByType {
    asc = 'asc',
    desc = 'desc',
    ASC = 'ASC',
    DESC = 'DESC'
}
export enum PathsV1PlayerPlayerGetAllUsersGetParametersQueryOrderByType {
    asc = 'asc',
    desc = 'desc',
    ASC = 'ASC',
    DESC = 'DESC'
}
export enum PathsV1UserGetParametersQueryOrderByType {
    asc = 'asc',
    desc = 'desc',
    ASC = 'ASC',
    DESC = 'DESC'
}
export enum PathsV1UserUserFlagLogsDataGetParametersQueryOrderByType {
    asc = 'asc',
    desc = 'desc',
    ASC = 'ASC',
    DESC = 'DESC'
}
export enum PathsV1UserIndexWithFlagsGetParametersQueryOrderByType {
    asc = 'asc',
    desc = 'desc',
    ASC = 'ASC',
    DESC = 'DESC'
}
export enum BlockCategory {
    legacy = 'legacy',
    manual = 'manual',
    self_exclusion = 'self-exclusion',
    mentor = 'mentor',
    one_month_unconfirmed = 'one-month-unconfirmed',
    inactivity = 'inactivity',
    cpr_validation_failed = 'cpr-validation-failed',
    multi_accounting = 'multi-accounting',
    multi_accounting_in_gamstop = 'multi-accounting-in-gamstop',
    pep = 'pep',
    sanctioned = 'sanctioned',
    underage = 'underage',
    game_scanner = 'game-scanner',
    missing_source_of_funds = 'missing-source-of-funds',
    missing_additional_information = 'missing-additional-information',
    chargeback = 'chargeback',
    fraud = 'fraud',
    excluded_by_gambling_authority = 'excluded-by-gambling-authority',
    aml = 'aml',
    failed_deposits = 'failed-deposits'
}
export enum BlockDuration {
    two_hours = 'two-hours',
    end_of_day = 'end-of-day',
    one_day = 'one-day',
    one_week = 'one-week',
    two_weeks = 'two-weeks',
    one_month = 'one-month',
    six_weeks = 'six-weeks',
    six_months = 'six-months',
    one_year = 'one-year',
    two_years = 'two-years',
    three_years = 'three-years',
    four_years = 'four-years',
    five_years = 'five-years',
    indefinite = 'indefinite'
}
export enum BlockType {
    block = 'block',
    cooldown = 'cooldown',
    deactivation = 'deactivation',
    suspension = 'suspension'
}
export enum Brand {
    spilnu = 'spilnu',
    happytiger = 'happytiger',
    spinking = 'spinking',
    bingoburst = 'bingoburst'
}
export enum ContactType {
    email = 'email',
    phone = 'phone'
}
export enum PlayerEventLogType {
    Value3 = 3,
    Value4 = 4,
    Value5 = 5,
    Value6 = 6,
    Value7 = 7,
    Value8 = 8,
    Value9 = 9,
    Value10 = 10,
    Value11 = 11,
    Value12 = 12,
    Value13 = 13,
    Value14 = 14,
    Value15 = 15,
    Value16 = 16,
    Value17 = 17
}
export enum PlayerFlagLogType {
    Value1 = 1,
    Value2 = 2
}
export enum PlayerReportStateTypes {
    unprocessed = 'unprocessed',
    processing = 'processing',
    processed = 'processed',
    downloaded = 'downloaded',
    failed = 'failed'
}
export enum PublicErrorCodes {
    PA_1100 = 'PA:1100',
    PA_1101 = 'PA:1101',
    PA_1102 = 'PA:1102',
    PA_1103 = 'PA:1103',
    PA_1200 = 'PA:1200',
    PA_1201 = 'PA:1201',
    PA_1202 = 'PA:1202',
    PA_1203 = 'PA:1203',
    PA_1204 = 'PA:1204'
}
export enum UserCheckResultType {
    suspended = 'suspended',
    suspended_missing_sof = 'suspended-missing-sof',
    deactivated = 'deactivated',
    block = 'block',
    expired_block_must_be_removed_by_customer_service = 'expired-block-must-be-removed-by-customer_service',
    cooldown = 'cooldown',
    gdc_check_failed = 'gdc-check-failed',
    extended_kyc_check_required = 'extended-kyc-check-required',
    oces_login_required = 'oces-login-required',
    multi_account = 'multi-account'
}
export enum UserPartnerRequestPartner_id {
    Value333 = '333',
    Value334 = '334',
    Value335 = '335',
    Value336 = '336',
    Value337 = '337'
}
export enum UserValidationStatus {
    Value1 = 1,
    Value2 = 2,
    Value3 = 3,
    Value4 = 4,
    Value5 = 5
}
